import React, { memo } from 'react'
import { BounceLoader } from 'react-spinners'

type Props = {
    loading: boolean
    children: React.ReactNode
    /** Defaults to the customer theme's colour; the BPS admin pages pass --app-primary. */
    color?: string
}

const CommonLoadingSpinner: React.FC<Props> = memo((props: Props) => {
    return props.loading ? <div data-testid="spinner" className='loadingContainer'>
        <BounceLoader color={props.color ?? "var(--customer-primary)"} />
    </div>
        : <>
            {props.children}
        </>
})

export default CommonLoadingSpinner